module.exports = __webpack_public_path__ + "img/Girl_010013.419d261f.png";